import { createContext, useContext } from "react";
import { PropriedadeCatalogo } from "@/models/consignado/disparo.model";

export type FiltroSelectFn = (propriedade: PropriedadeCatalogo) => void;

type FiltroActiveContextValue = {
  // `key` identifica quem está pedindo o campo (o id do filtro) — permite
  // que só o dono da ativação consiga limpá-la (ver clearActiveFiltro).
  registerActiveFiltro: (key: string, onSelect: FiltroSelectFn) => void;
  // Limpa o alvo ativo, mas só se `key` ainda for o dono — evita que
  // remover um filtro feche a escolha de campo de OUTRO que porventura
  // esteja ativo no momento.
  clearActiveFiltro: (key: string) => void;
  // Quem está pedindo o campo agora — o botão "+" / "( )" usa para aparecer
  // destacado enquanto a escolha da nova condição está pendente.
  activeKey?: string | null;
};

/** Chaves do alvo pendente de "+" (condição) e "( )" (subgrupo) de um grupo. */
export const chaveNovaCondicao = (grupoId: string) => `nova-condicao:${grupoId}`;
export const chaveNovoSubgrupo = (grupoId: string) => `novo-subgrupo:${grupoId}`;

// Contexto que liga a sidebar (o "column picker" do query builder) ao
// filtro sendo editado no momento — mesmo padrão do VariavelInsertContext
// pros campos de mensagem: cada pill se registra como "alvo ativo" ao ser
// clicada; a sidebar escolhe sempre pro último alvo registrado, e a lista
// de campos só aparece enquanto existir um alvo ativo.
//
// A lista oferecida é a allowlist do backend (GET /catalogo/entidades),
// filtrada pelas propriedades que declaram operador — não um catálogo nosso.
export const FiltroActiveContext = createContext<FiltroActiveContextValue>({
  registerActiveFiltro: () => {},
  clearActiveFiltro: () => {},
});

export const useFiltroActive = () => useContext(FiltroActiveContext);
